import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Branch } from 'src/app/ndm/models/branch.model';
import { IdNameModel } from 'src/app/ndm/models/idName.model';
import { CreateUser } from 'src/app/ndm/models/user.model';
import { WholeSaler } from 'src/app/ndm/models/wholesaler.model';
import { AuthService } from 'src/app/services/authenticate.service';
import { BranchService } from 'src/app/services/branch.service';
import { MasterService } from 'src/app/services/masters.service';
import { NotificationService } from 'src/app/services/notification.service';
import { UserService } from 'src/app/services/user.service';
import { WholesalerService } from 'src/app/services/wholesaler.service';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import * as constants from '../../../../config/app.constants';
import { Base_pageComponent } from '../../base_page/base_page.component';
import { PasswordValidator } from './password.validator';

@Component({
    selector: 'app-add_user',
    templateUrl: 'add_user.component.html',
    styleUrls: ['add_user.component.css'],
    standalone: false
})
export class Add_userComponent extends Base_pageComponent implements OnChanges, OnInit {
  levels: IdNameModel[] = [];
  parentTypes: any[] = [];
  form: FormGroup = new FormGroup({});
  userId: number = 0;
  createUser: CreateUser = new CreateUser();
  wholeSalers: WholeSaler[] = [];
  branchList: Branch[] = [];
  userInfo: any;
  @Input() isFromRegister: Boolean;
  constructor(
    private readonly router: Router,
    private readonly toast: NotificationService,
    private readonly loader: LoaderService,
    private readonly activeRoute: ActivatedRoute,
    private readonly userService: UserService,
    private readonly wholesalerService: WholesalerService,
    private readonly branchService: BranchService,
    private readonly authService: AuthService,
    private masterService: MasterService,
    private readonly title: Title
  ) {
    super('edit_user', masterService, title);

    this.levels = constants.Levels;
    this.parentTypes = constants.ParentTypes;
    if (this.isFromRegister) {
      this.createUser.parentType = "U"
    }

    this.initiateFormGroup();

    this.activeRoute.params.subscribe((params: Params) => {
      if (Object.keys(params).length > 0) {
        if (params['id'] != null) {
          this.userId = params['id'];
          if (this.userId > 0) {
            this.getUserById();
          }
        }
      }
    });

    this.userInfo = this.authService.getToken() == undefined ? null : this.authService.getToken();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isFromRegister']) {
      this.createUser.parentType = changes['isFromRegister'].currentValue == true ? "U" : this.createUser.parentType;
      if (this.createUser.parentType == "U") {
        this.form.get("parentType")?.setValue("U");
        this.form.get("level")?.setValue("16");
      }
    }
  }

  initiateFormGroup() {
    this.form = new FormGroup({
      'id': new FormControl(this.createUser.id),
      'password': new FormControl(this.createUser.password, [Validators.required, PasswordValidator.strong]),
      'userName': new FormControl(this.createUser.userName, [Validators.required]),
      'level': new FormControl(this.createUser.level, [Validators.required, Validators.min(0)]),
      'parentType': new FormControl(this.createUser.parentType, [Validators.required]),
      'parentId': new FormControl(this.createUser.parentId),
      'firstName': new FormControl(this.createUser.firstName, [Validators.maxLength(100)]),
      'lastName': new FormControl(this.createUser.lastName, [Validators.maxLength(100)]),
      'company': new FormControl(this.createUser.company, [Validators.maxLength(100)]),
      'postcode': new FormControl(this.createUser.postcode, [Validators.pattern("^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) {0,1}[0-9][A-Za-z]{2})$")]),
      'tel': new FormControl(this.createUser.tel),
      'email': new FormControl(this.createUser.email, [Validators.required, Validators.pattern(constants.VALIDATE_EMAIL_ADDRESS)]),
    });

    this.form.get("parentType")?.valueChanges.subscribe(item => {
      this.form.patchValue({
        firstName: '',
        lastName: '',
        company: '',
        postcode: '',
        tel: '',
        parentId: 0
      });

      this.form.get('tel')?.clearValidators();
      this.form.get('postcode')?.clearValidators();
      this.form.get('parentId')?.clearValidators();
      this.form.get('parentId')?.setValue(0);
      if (item == 'W' || item == 'B') {
        this.form.get('parentId')?.setValidators([Validators.required, Validators.min(1)])
      }

      if (item == 'U') {
        this.form.get('tel')?.setValidators([Validators.pattern(/^-?([0-9]\d*)?$/)])
        this.form.get('postcode')?.setValidators([Validators.required, Validators.pattern("^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) {0,1}[0-9][A-Za-z]{2})$")])
      }

      this.form.get('parentId')?.updateValueAndValidity();
      this.form.get('tel')?.updateValueAndValidity();
      this.form.get('postcode')?.updateValueAndValidity();

    });

  }

  patchUserInfo() {
    if (this.userId > 0) {
      this.form.get('password')?.clearValidators();
      this.form.get('password')?.updateValueAndValidity();
    }
    this.form.patchValue({
      id: this.createUser.id,
      userName: this.createUser.userName,
      level: this.createUser.level,
      parentType: this.createUser.parentType,
      parentId: this.createUser.parentId,
      firstName: this.createUser.firstName,
      lastName: this.createUser.lastName,
      company: this.createUser.company,
      postcode: this.createUser.postcode,
      tel: this.createUser.tel,
      email: this.createUser.email,
    });
  }

  ngOnInit(): void {
    if (!this.isFromRegister) {
      this.loader.start();
      this.getAllWholsesaler();
      this.getAllBranchData();
    }
  }

  getAllWholsesaler() {
    this.wholesalerService.getAllWholesalerList().subscribe(res => {
      this.wholeSalers = res;
      if (this.userId <= 0) {
        this.loader.stop();
      }
    },
      (error: any) => {
        this.loader.stop();
        this.toast.showException(error.error);
      }
    );
  }

  getAllBranchData() {
    this.branchService.getBranchList(0, 100).subscribe(res => {
      this.branchList = res.content;
      if (this.userId <= 0) {
        this.loader.stop();
      }
    });
  }

  getUserById() {
    this.loader.start();
    this.userService.getUserById(this.userId).subscribe(res => {
      this.createUser = res;
      this.patchUserInfo();
      this.loader.stop();
    },
      (error: any) => {
        this.loader.stop();
        this.toast.showException(error.error);
      }
    );
  }


  reset() {
    this.form.reset();

    if (this.userId > 0) {
      this.getUserById();
    } else {
      this.createUser = new CreateUser();
      if (this.isFromRegister) {
        this.createUser.parentType = "U"
      }
      this.patchUserInfo();
    }

      // this.ngOnInit();

    // setTimeout(() => {
    //   this.loader.stop();
    // }, 200);

    this.form.controls['level'].markAsUntouched();
  }

  submit() {
    if (this.validatePage()) {
      let saveData = this.form.value;
      saveData.firstName = saveData.firstName == "" ? null : saveData.firstName;
      saveData.lastName = saveData.lastName == "" ? null : saveData.lastName;
      saveData.company = saveData.company == "" ? null : saveData.company;
      saveData.postcode = saveData.postcode == "" ? null : saveData.postcode;
      saveData.tel = saveData.tel == "" ? null : saveData.tel;
      saveData.email = saveData.email == "" ? null : saveData.email;

      if (this.isFromRegister) {
        this.registerUser(saveData);
      } else {
        if (this.userId > 0) {
          this.updateUser(saveData);
        } else {
          this.saveUser(saveData);
        }
      }
    }
  }

  registerUser(createUser: CreateUser) {
    this.loader.start();
    this.authService.registerUser(createUser).subscribe(res => {
      this.loader.stop();
      this.toast.showSuccess("User account created successfully");
      this.router.navigate(['./home']);
    },
      (error: any) => {
        this.loader.stop();
        this.toast.showException(error.error);
      }
    )
  }

  saveUser(createUser: CreateUser) {
    this.loader.start();
    this.userService.saveUser(createUser).subscribe(res => {
      this.loader.stop();
      this.toast.showSuccess("User account created successfully");
      this.router.navigate(['../management/user']);
    },
      (error: any) => {
        this.loader.stop();

        this.toast.showException(error.error);
      }
    )
  }

  updateUser(updateUser: CreateUser) {
    this.loader.start();
    this.userService.updateUser(updateUser.id, updateUser).subscribe(res => {
      this.loader.stop();
      this.toast.showSuccess("User account updated successfully");
      this.router.navigate(['../management/user']);
    },
      (error: any) => {
        this.loader.stop();
        this.toast.showException(error.error);
      }
    )
  }

  validatePage(): boolean {
    Object.keys(this.form.controls).forEach(key => {
      if (key !== null) {
        this.form.get(key)?.markAsDirty();
        this.form.get(key)?.markAsTouched();
      }
    })
    return this.form.valid;
  }
}